import momentCN from 'moment/locale/zh-cn'

const components = {
  momentName: 'zh-cn',
  momentLocale: momentCN
}

const locale = {
  'message': '-',
  'layouts.application': '应用',
  'layouts.current': '正在使用',
  'layouts.switch': '切换',
  'layouts.onlineservice': '在线客服',
  'layouts.usercenter': '用户中心',
  'layouts.helpcenter': '帮助中心',
  'layouts.logout': '退出系统',
  'layouts.allapplication': '全部应用',
  'layouts.history': '最近打开',
  'layouts.customscene': '自定义场景',
  'layouts.commonmenu': '常用菜单',
  'layouts.search.placeholder': '请输入关键词，搜索菜单',
  'layouts.text.undefined': '暂无数据',
  'form-modal.cancel': '取消',
  'form-modal.submit': '确认',
  'form-modal.selected': '已选中',
  'form-modal.action': '个操作',
  'form-modal.custom.title': '自定义场景面板',
  'form-modal.system.title': '自定义应用菜单',
  'form-modal.menuname.placeholder': '请输入自定义场景名称',
  'form-modal.remark.placeholder': '备注',
  'please_download_and_view请下载后查看': '当前日志已超过1000字，为了您的查看体验，请下载后查看'
}

export default {
  ...components,
  ...locale
}
